import MiniDrawer from "../ui/MiniDrawer";

export default function Dashboard() {
  return (
    <div className="">
      <MiniDrawer />
    </div>
  );
}
